export default "__VITE_ASSET__FW7w7Acx__"